import Model  from '@/util/models';
import Provinsi from './Provinsi';

export default class Kota extends Model { 
    backend = '/frc/kota/'; 
    
    getProvinsi(){       
        let provinsi = new Provinsi;
        return provinsi.all();        
    }
}

